import { StorageSerializers, useSessionStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import type { CreditType } from '@core/config/credit-types/credit-type.types.ts';
import {
  CreditTypeStyleMapping,
  type GetCreditTypeStyleProps,
} from '@core/utils/credits/credit-type-mapping.ts';

export const useCreditTypesStore = defineStore('creditTypes', () => {
  const creditTypes = useSessionStorage<CreditType[] | null>(
    'creditTypes',
    null,
    { serializer: StorageSerializers.object },
  );

  const setCreditTypes = (availableCreditTypes: CreditType[] | null) => {
    creditTypes.value = availableCreditTypes;
  };

  const reset = () => {
    creditTypes.value = [];
  };

  const getCreditTypeStyleByName = ({
    name,
    selected,
  }: GetCreditTypeStyleProps) => {
    return CreditTypeStyleMapping({
      name,
      selected,
    });
  };

  const getCreditTypeById = (id: string) => {
    return creditTypes.value?.find((creditType) => creditType.id === id);
  };

  const getCreditTypeStyleById = (id: string) => {
    const creditType = getCreditTypeById(id);
    return CreditTypeStyleMapping({
      name: creditType?.name,
      selected: false,
    });
  };

  return {
    reset,
    setCreditTypes,
    creditTypes,
    getCreditTypeStyleByName,
    getCreditTypeById,
    getCreditTypeStyleById,
  };
});
